module.exports = __webpack_public_path__ + "static/lottery-logo-66e1d883ee08017fef04970d54663159.png";